import React from 'react'
import { IconProps } from '../types'

export default function SparkleIcon({
    className = 'h-[22px] w-[18px]',
    fill = '#0A84FF',
    ...props
}: IconProps) {
    return (
        <svg
            width="18"
            height="22"
            viewBox="0 0 18 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M11.0597 2.15683C10.9704 4.93035 11.986 6.98734 13.0574 9.0097C13.448 9.73775 14.1065 10.0613 14.9212 10.0151C15.5127 9.98045 16.1042 9.94578 16.6957 9.98044C17.343 10.0267 17.8564 10.5005 17.9791 11.0783C18.0907 11.5868 17.7448 12.3148 17.1756 12.5922C16.785 12.7886 16.3386 13.0198 15.9145 13.0198C14.4524 13.0313 13.6266 13.9674 12.9012 15.0768C12.0418 16.3595 11.5731 17.8156 11.1601 19.2948C10.9927 19.8842 10.8476 20.4736 10.6468 21.0514C10.457 21.5945 10.0887 21.9759 9.49723 21.999C8.91689 22.0221 8.51512 21.6408 8.24727 21.167C8.0687 20.8434 7.95709 20.462 7.90129 20.0922C7.76736 19.2602 7.71158 18.4165 7.58882 17.5729C7.26517 15.3888 5.31208 13.5282 3.22509 13.378C2.55546 13.3318 1.88585 13.3318 1.22739 13.2393C0.580083 13.1469 0.0890087 12.6268 0.0108859 12.0721C-0.0783974 11.4481 0.390334 10.7432 1.09344 10.5236C1.80771 10.3156 2.54431 10.2116 3.25857 10.0036C6.11564 9.19461 7.62229 7.34559 7.91246 4.27161C7.99058 3.5089 7.96826 2.73464 8.02406 1.97192C8.0687 1.24387 8.38121 0.654512 8.98387 0.250041C9.83206 -0.316218 10.8811 0.122905 11.0262 1.1283C11.1155 1.59056 11.0597 2.05282 11.0597 2.15683Z"
                fill={fill}
            />
        </svg>
    )
}
